import { render, staticRenderFns } from "./TransactionSummaryPopup.vue?vue&type=template&id=21531cc2&scoped=true"
import script from "./TransactionSummaryPopup.vue?vue&type=script&lang=js"
export * from "./TransactionSummaryPopup.vue?vue&type=script&lang=js"
import style0 from "./TransactionSummaryPopup.vue?vue&type=style&index=0&id=21531cc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21531cc2",
  null
  
)

export default component.exports